<template>
  <div>
    <el-dialog
      v-model="isInput"
      append-to-body
      :destroy-on-close="true"
      :show-close="false"
      :modal="true"
      :close-on-click-modal="false"
      :class="pdheight== 'auto' ? 'application-routing-dialog-all dialog-height-auto' : 'application-routing-dialog-all'"
      :fullscreen="routingFlowshow"
      :top="routingFlowshow ? '0' : '8.9vh'"
      :width="routingFlowshow ? '100%' : isUsePx ? (pdwidth + 'px') : (pdwidth + '%')"
      :style="showLink ? 'display:none' : ''"
    >
      <div :class="['dialog-top', isfaceAr !== 0 ? 'dialog-top-black' : '']">
        <div class="apply-name">{{ applyInfo.name }}</div>
        <div class="apply-right">
          <div class="face-ar" v-if="isfaceAr !== 0">
            <span
              class="active-hover"
              @click="faceArChange"
            >
              <i
                v-show="isfaceAr === 1"
                class="iconfont icon-AR1"
                style="font-size: 20px"
              />
              <i
                v-show="isfaceAr === 2"
                class="iconfont icon-AR"
                style="font-size: 20px"
              />
            </span>
          </div>
          <div v-if="isAi" class="active-hover" @click="upIsAi(isAi === 1 ? 2 : 1)"
            :style="{color: isAi === 1 ? '#4e86ff' : ''}">
            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
            AI小易
          </div>
          <div v-if="flowshow != 2">
            <span class="active-hover"  @click="onFlowshow">
              <i class="el-icon-view" />
              {{ getFlowShowText() }}
            </span>
          </div>
          <div>
            <span
              class="active-hover"
              style="margin-right: 5px"
              @click="routingFlowshow = !routingFlowshow"
            >
              <i
                v-show="!routingFlowshow"
                class="iconfont icon-fangda2"
                style="font-size: 14px"
              />
              <i
                v-show="routingFlowshow"
                class="iconfont icon-suoxiao1"
                style="font-size: 14px"
              />
            </span>
            <span class="active-hover" @click="isInput = false">
              <i class="icon iconfont icon-shanchu3" />
              <!--                关闭-->
            </span>
          </div>
        </div>
      </div>
      <oaExamineInput
        :external="false"
        :approvalId="applyInfo.id || applyInfo.approvalId"
        :coverVal="coverVal"
        :modify="null"
        :person="1"
        v-model:isAi="isAi"
        v-model:pdwidth="pdwidth"
        :isAllAdd="isAllAdd"
        :pageType="pageType"
        type="1"
        ref="AuditOpenInput"
        @hideLink="hideLink"
        @inputClose="inputClose"
        @retRefresh="retRefresh"
        @refFlowshow="refFlowshow"
        @getfaceAr="getfaceAr"
        @upIsAi="upIsAi"
        @upIsPcwidth="upIsPcwidth"
        @upIsPcHeight="upIsPcHeight"
        @loadSuccess="loadSuccess"
        v-if="isInput"
      />
    </el-dialog>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'oaAddExamineInput',
  data () {
    return {
      //显示放大缩小
      routingFlowshow: false,
      // 显示输入表单
      isInput: false,
      // 流程查看显示
      flowshow: 2,
      isAi: 0,
      isfaceAr: 0, //0 未配置人脸识别 1 拍摄模式 2 AR模式
      pdwidth:75,
      isUsePx: false,
      pdheight: 'regular',
      showModal: false, //是否显示遮罩层
      showLink: false // 是否隐藏当前弹出窗口（但是不关闭）
    };
  },
  props: {
    // 应用的信息
    applyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isViews: {
      type: Boolean,
      default: false
    },
    coverVal:{
      type: Object,
      default: () => ({})
    },
    isAllAdd: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  watch: {
    isViews: {
      immediate: true,
      handler (val) {
        if (val) {
          this.showModal = true
          document.body.classList.add('rout-opendialog');
          this.isInput = val
        }
      }
    },
    showModal (val) {
      console.log("showModal==",val,this.isInput);
      if (!val && this.isInput) {
        this.addMask();
      } else {
        this.removeMask();
      }
    },
    isInput: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.$emit('update:isViews', false)
          if(!this.showModal){
            this.removeMask();
          }
        }
      }
    }
  },
  components: {
    oaExamineInput: defineAsyncComponent(() => import('@/components/clientSide/oaExamineInput.vue')),
  },

  methods: {
    getFlowShowText () {
      let str = '流程'
      if (this.applyInfo && this.applyInfo.baseset) {
        const baseset = typeof this.applyInfo.baseset === 'string' ? JSON.parse(this.applyInfo.baseset) : this.applyInfo.baseset
        if (baseset.flowshow && baseset.flowshow.type) {
          if (baseset.flowshow.viewText) {
            str = baseset.flowshow.viewText
          } else {
            str = baseset.flowshow.type === 'dialogue' ? '交流' : '流程'
          }
        }
      }
      return str
    },
    hideLink () {
      this.showLink = true
    },
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1
      this.$refs.AuditOpenInput.flowshow = this.flowshow
    },
    refFlowshow (e) {
      this.flowshow = e
    },
    // 隐藏输入表单
    inputClose () {
      this.isInput = false
    },
    // 确定传入后端后，通知表格更新数据。
    retRefresh () {
      this.$emit('updateTable')
    },
    upIsPcwidth (val, isUsePx = false) {
      this.pdwidth = val
      this.isUsePx = isUsePx
    },
    upIsPcHeight(val){
      this.pdheight = val
    },
    // 弹窗完成加载
    loadSuccess(){
      console.log('弹窗完成加载',this.showModal)
      setTimeout(() => {
        document.body.classList.remove('rout-opendialog');
        this.showModal = false
      }, 300);
    },
    upIsAi (val) {
      this.isAi = val
    },
    // 获取人脸识别是否打开
    getfaceAr(val){
      this.isfaceAr = val
      if(this.isfaceAr !== 0){
        this.routingFlowshow = true
      }
      else{
        this.routingFlowshow = false
      }
      console.log("this.isfaceAr==",this.isfaceAr);
    },
    // 切换人脸识别模式
    faceArChange(){
      this.isfaceAr = this.isfaceAr === 1 ? 2 : 1
      this.$refs.AuditOpenInput.faceArChange(this.isfaceAr)
    },
    addMask() {
      const existingMask = document.getElementById('j-mask-dialogB');
      if (existingMask) {
        // 如果遮罩层已经存在，跳过创建步骤
        return;
      }
      // 创建遮罩层元素
      const mask = document.createElement('div');
      mask.id = 'j-mask-dialogB';
      mask.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99;
        transition: opacity 0.3s;
        opacity: 0;
      `;
      // 使用 setTimeout 模拟遮罩层渐变效果
      setTimeout(() => {
        mask.style.opacity = 1;
      }, 10);
      
      // 将遮罩层添加到 body
      document.body.appendChild(mask);
      
      // 点击遮罩层关闭弹窗
      mask.onclick = () => {
        this.showModal = false;
      };
    },
    removeMask() {
      // 获取遮罩层元素
      const mask = document.getElementById('j-mask-dialogB');
      if (mask && mask.parentNode) {
        mask.style.opacity = 0;
        setTimeout(() => {
          mask.parentNode && mask.parentNode.removeChild(mask);
        }, 300);
      }
    },
  },

  computed: {},
}
</script>
<style lang='scss' scoped>
::v-deep html,
::v-deep body,
::v-deep #app {
  height: 100%;
}
::v-deep .el-dialog.is-fullscreen {
  overflow: hidden;
}
.active-hover:hover {
  color: #4e86ff;
  i {
    color: #4e86ff;
  }
}
// pc弹窗高度-自适应
:deep(.dialog-height-auto) {
  min-height: inherit;
  .oaExamineInput {
    position: inherit;
    .oaExamineAllArea {
      .wisdomSubmit {
        .wisdomSubmitBox {
          position: inherit;
        }
      }
    }
  }
}

::v-deep .oaExamineInput {
  .wisdomSubmit {
    .inputBoxArea  {
      .el-scrollbar__view {
        max-height: 75vh !important;
      }
    }
  }
}

/*修改滚动条样式*/
::v-deep .application-routing-dialog-all::-webkit-scrollbar {
  position: absolute;
  right: 0;
  top: 0;
  width: 10px;
  height: 10px;
  z-index: 999;
  /**/
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 2px;
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  // background: rgba(255 ,253,246, 0.9);
  border-radius: 10px;
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-corner {
  background: transparent;
}
.task-routing-title {
  position: relative;
  line-height: 20px;
  .title-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }
  .task-icon {
    position: absolute;
    right: 40px;
    top: 0;
    color: #999999;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
}
.mom-button {
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  margin-left: 20px;
  .icon-gengduo {
    color: #999999;
    font-size: 12px;
    margin-left: 7px;
  }
  .icon-round {
    width: 8px;
    height: 8px;
    background: #e47470;
    border-radius: 50%;
    margin-right: 7px;
    display: inline-block;
  }
}
.mom-block {
  padding-top: 6px;
  padding-bottom: 6px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  .mom-block-list {
    cursor: pointer;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 26px;
    color: #ffffff;
    position: relative;
    &:hover {
      background: rgba(241, 248, 255, 0.12);
    }
    .icon-round {
      width: 8px;
      height: 8px;
      background: #e47470;
      border-radius: 50%;
      display: inline-block;
      position: absolute;
      left: 10px;
      top: 12px;
    }
  }
  .active {
    background: rgba(241, 248, 255, 0.12);
  }
}
.rout-opendialog {
  .el-dialog__wrapper {
    ::v-deep .application-routing-dialog-all {
      opacity: 0 !important;
    }
  }
}
.dialog-top-black {
  background: #000;
  border-bottom: 1px solid #000;
  .apply-name {
    color: #fff;
  }
  .apply-right {
    color: #fff;
    &>div{
      border-left: 1px solid #333;
    }
  }
}
.dialog-top-black-close {
  z-index: 1999;
}

</style>